import { Tooltip } from '@mui/material';
import { FunctionComponent, HTMLAttributes } from 'react';
import { HiExclamationTriangle } from 'react-icons/hi2';

interface FiguresAlertProps
  extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {}

const FiguresAlert: FunctionComponent<FiguresAlertProps> = ({
  className,
  ...props
}) => {
  return (
    <Tooltip
      title="Figures alert"
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          className:
            'bg-amber-50 text-amber-700 ring-amber-200 border border-gray-200 shadow-sm',
        },
        arrow: {
          className: 'text-amber-500',
        },
      }}
    >
      <span className={className} {...props}>
        <HiExclamationTriangle
          className="h-4 w-4 text-amber-500"
          aria-label="Figures alert"
        />
      </span>
    </Tooltip>
  );
};

export default FiguresAlert;
